interface ValuationRate<C extends string> {
	currency: C;
	historical: number | null;
	custom: number | null;
}

/**
 * Currencies in use with neither a custom nor a provider rate; the base currency needs none.
 * Sorted, so the error that lists them reads the same whatever order the inputs came in.
 */
export const findCurrenciesWithoutRate = <C extends string>(
	base: C,
	currenciesInUse: Iterable<C>,
	rates: ReadonlyArray<ValuationRate<C>>
): C[] => {
	const rated = new Set(
		rates
			.filter((rate) => (rate.custom ?? rate.historical) !== null)
			.map((rate) => rate.currency)
	);
	return [...new Set(currenciesInUse)]
		.filter((currency) => currency !== base && !rated.has(currency))
		.sort();
};
